<template>
    <section> 
        <div class="row">
            <div class="col s12">
                <div class="card-panel" style="border: 2px solid #8c9eff">
                    <div class="row">
                        <h5 class="col s12">
                            Resultado da Análise Técnica
                        </h5>
                    </div>
                    <div class="row">
						<div class="input-field col s6">
							<input type="text"
								   class="notas"
								   readonly
								   v-model="inscricao.turma.nota_turma[0] + ' h'">
							<label><b>Carga horária total</b>
							</label>
						</div>
						<div class="input-field col s6">
							<input type="number"
								   class="notas"
								   readonly
								   v-model="inscricao.turma.nota_turma[1]">
							<label><b>Nota</b>
							</label>
						</div>
					</div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "resultado_avaliacoes_qtdo_evento",
    props: {
		inscricao: {
			type: Object|null,
			default: null
		},
    }
}
</script>